function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5165 0.421034C13.0778 0.982413 13.0778 1.89259 12.5165 2.45397L3.47043 11.5L12.5165 20.546C13.0778 21.1074 13.0778 22.0176 12.5165 22.579C11.9551 23.1403 11.0449 23.1403 10.4835 22.579L0.421034 12.5165C-0.140345 11.9551 -0.140345 11.0449 0.421034 10.4835L10.4835 0.421034C11.0449 -0.140345 11.9551 -0.140345 12.5165 0.421034Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.6727 4.73353C15.2341 5.29491 15.2341 6.20509 14.6727 6.76647L9.93918 11.5L14.6727 16.2335C15.2341 16.7949 15.2341 17.7051 14.6727 18.2665C14.1113 18.8278 13.2012 18.8278 12.6398 18.2665L6.88978 12.5165C6.32841 11.9551 6.32841 11.0449 6.88978 10.4835L12.6398 4.73353C13.2012 4.17216 14.1113 4.17216 14.6727 4.73353Z",
  fill: "black"
});

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.97173f1a.svg";
export { ForwardRef as ReactComponent };